import MainHero from "../components/MainHero";
import MainIntro from "../components/MainIntro";
import MainContent from "../components/MainContent";
import "../styles/Home.css";

export default function Home() {
  return (
    <div className="home">
      <MainHero />
      <MainIntro />
      <MainContent />
    </div>
  );
}
